
<div class="row mx-n2 mx-sm-n3 pt-4" *ngIf="productListingData.selectedFormat == 1 || productListingData.selectedFormat == null">
  <div *ngFor="let product of products" class="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 px-2 px-sm-3 mb-3 mb-sm-5">
    <!-- Product -->
    <div class="card text-center h-100">
      <div [routerLink]="[product.id]" class="position-relative">
        <img class="card-img-top" src="/fetchimage?fileName={{ product.marketingSplash }}&mode=crop&width=900&height=540" [fallback]="'https://bxlimages.blob.core.windows.net/splash/noimage.png'"  />
        <div class="position-absolute top-0 left-0 pt-3 pl-3">
          <span *ngIf="product.remainingQuantity >= 3" class="badge badge-success badge-pill">{{ product.remainingQuantity }} remaining</span>
          <span *ngIf="product.remainingQuantity < 3 && product.remainingQuantity != 0" class="badge badge-warning badge-pill">{{ product.remainingQuantity }} remaining</span>
          <span *ngIf="product.remainingQuantity == 0" class="badge badge-danger badge-pill">Sold Out</span>
        </div>
      </div>

      <div class="card-body pt-4 px-4 pb-0">
        <div class="mb-2">
          <!-- <a class="d-inline-block text-secondary small font-weight-medium mb-1" href="#">Accessories</a> -->
          <h3 class="font-size-1 font-weight-normal">
            <a class="text-secondary" [routerLink]="[product.id]">{{ product.title }}</a>
          </h3>
          <div class="d-block font-size-1">
            <span class="font-weight-medium">{{ product.price | currency: conference.sponsorCurrency }}</span>
          </div>
        </div>
      </div>

      <div class="card-footer border-0 pt-0 pb-4 px-4">
        <ng-container *ngIf="product.remainingQuantity > 0">
          <a role="button" [routerLink]="['../call-for-sponsors', product.id]" class="btn btn-sm btn-outline-primary btn-sm-wide btn-pill transition-3d-hover">View Details</a>
        </ng-container>
        <button *ngIf="product.remainingQuantity == 0" type="button" disabled class="btn btn-sm btn-warning btn-sm-wide btn-pill transition-3d-hover">Sold Out</button>
      </div>
    </div>
    <!-- End Product -->
  </div>

  <!-- End Product -->
</div>

<div class="mx-n2 mx-sm-n3 mt-4 accordion" *ngIf="productListingData.selectedFormat == 2">
  <ng-container *ngFor="let product of products; let idx = index">
    <div class="card">
      <div class="card-header card-collapse" id="cardHeadingOne{{ idx }}">
        <h5 class="mb-0">
          <button class="btn btn-link btn-block card-btn p-3 collapsed" role="button" data-toggle="collapse" [attr.data-target]="'#cardOne' + idx" aria-expanded="false" [attr.aria-controls]="'#cardOne' + idx">
            <span class="row align-items-center">
              <span class="col-md-6 mb-2 mb-md-0">
                <span class="media align-items-center">
                  <i class="fas fa-box mr-2"></i>
                  <span class="media-body">
                    <span class="font-size-1">{{ product.title }}</span>

                  </span>
                </span>
              </span>
              <span class="col-md-6 text-md-right mb-2">

               </span>
              <span class="col-md-6 col-md-3">
                <span class="d-block font-size-1">{{ product.price | currency }}</span>
                <span *ngIf="product.remainingQuantity >= 3" class="badge badge-success badge-pill">{{ product.remainingQuantity }} remaining</span>
                <span *ngIf="product.remainingQuantity < 3 && product.remainingQuantity != 0" class="badge badge-warning badge-pill">{{ product.remainingQuantity }} remaining</span>
                <span *ngIf="product.remainingQuantity == 0" class="badge badge-danger badge-pill">Sold Out</span>
              </span>
              <span class="col-md-6 text-right">
                <ng-container *ngIf="product.remainingQuantity > 0">
                  <a role="button" [routerLink]="['../call-for-sponsors', product.id]" class="btn btn-xs btn-primary mt-3">View Details</a>
                </ng-container>
                <button *ngIf="product.remainingQuantity == 0" type="button" disabled class="btn btn-xs btn-warning mt-3">Sold Out</button>

                <!-- <a role="button" class="btn btn-xs btn-primary mt-3" [routerLink]="['../call-for-sponsors', product.id]" >View Details</a> -->
              </span>
            </span>
          </button>
        </h5>
      </div>
    </div>
  </ng-container>

  <!-- End Product -->
</div>
